// @flow

import { CHECK_USER_LOGGEDIN_SUCCESS } from 'app/containers/Login/redux';
import { Map, fromJS } from 'immutable';

export const SEND_LOGIN_CODE = 'App/DirectLogin/SEND_LOGIN_CODE';
export const SEND_LOGIN_CODE_SUCCESS = 'App/DirectLogin/SEND_LOGIN_CODE_SUCCESS';
export const SEND_LOGIN_CODE_FAIL = 'App/DirectLogin/SEND_LOGIN_CODE_FAIL';
export const RESET_SEND_LOGIN_CODE = 'App/DirectLogin/RESET_SEND_LOGIN_CODE';

const initialState = Map({
  sendLoginCodeLoading: false,
  sendLoginSuccess: Map({}),
  sendLoginCodeFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case SEND_LOGIN_CODE:
      return state.merge({
        sendLoginCodeLoading: true,
        sendLoginCodeFail: null,
      });
    case SEND_LOGIN_CODE_SUCCESS:
      return state.merge({
        sendLoginCodeLoading: false,
        sendLoginSuccess: fromJS(action.data),
      });
    case SEND_LOGIN_CODE_FAIL:
      return state.merge({
        sendLoginCodeLoading: false,
        sendLoginCodeFail: fromJS(action.data),
      });
    case RESET_SEND_LOGIN_CODE:
      return state.merge({
        sendLoginCodeLoading: false,
        sendLoginSuccess: Map({}),
        sendLoginCodeFail: null,
      });

    default:
      return state;
  }
};

export const sendLoginCode = (data : string, refrenceRoute : string) => (dispatch : any) =>
  dispatch({ type: SEND_LOGIN_CODE, data, refrenceRoute });

export const resetSendLoginCode = () => (dispatch : any) =>
  dispatch({ type: RESET_SEND_LOGIN_CODE });

export const signinSso = (jwt : string) => (dispatch : any) =>
  dispatch({ type: CHECK_USER_LOGGEDIN_SUCCESS, data: { jwt } });
